import { Outlet } from 'react-router-dom'
import FloatingHelpButton from '@components/web/FloatingHelpButton'

export default function RootLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
      <FloatingHelpButton />
    </div>
  )
}
